module.exports = __webpack_public_path__ + "static/media/pic1@3x.091776ed.png";